import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Pagination, Select, Table } from "antd";
import ButtonGroup from "antd/es/button/button-group";
import Search from "antd/es/input/Search";
import { Option } from "antd/es/mentions";
import Modal from "antd/es/modal/Modal";
import moment from "moment";

import * as XLSX from "xlsx";

import nutrientsApi from "../../../../apis/Nutrients.api";
import {
  setLoading,
  setSearchText,
} from "../../../../redux/store/common/commonDuck";
/**
 * 승인 영양제
 * status : 1,      // 0 : 신청상태 , 1 : 헬시팀 컨펌
 * certify : true,  // false : 미인증 , true : 인증
 * confirm : 1      // 0 : 대기 , 1 : 승인 , 2 : 반려
 * **/

/**
 * pageType         // 1 : 인증 , 2 : 레시피(or 반려) , 3 : 신청 , 4 : 추가
 * target_type      // 1 : 음식 , 2 : 재료 , 3 : 영양제
 **/

const NutrientsCertifiedComponent = () => {
  let history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const searchText = useSelector((state) => state.common.searchText);

  const setIsLoading = (value) => dispatch(setLoading(value));
  const setIsSearchText = (value) => dispatch(setSearchText(value));

  let validVar = false;
  const typeValidation = ["string", "string", "string", "string", "number"];
  const [selectedData, setSelectedData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [excelHeaders, setExcelHeaders] = useState({
    kpiHeader: [],
    allergyHeader: [],
    infoHeader: [],
    totalHeader: [],
  });
  const [excelData, setExcelData] = useState([]);
  const [excelModalVisible, setExcelModalVisible] = useState(false);
  const [isButtonVisible, setIsButtonVisible] = useState(false);
  const [error, setError] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [offset, setOffset] = useState(0);
  const [totalSize, setTotalSize] = useState(100);
  const [searchType, setSearchType] = useState("vuon");
  const [orderType, setOrderType] = useState("");
  const [orderBy, setOrderBy] = useState("");
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [isSearch, setIsSearch] = useState(false);
  const [duplicationList, setDuplicationList] = useState(null);
  const [nutrientsData, setNutrientsData] = useState([]);

  const searchItems = [
    { searchType: "vuon", searchText: "뷰온검색" },
    { searchType: "name", searchText: "영양제명" },
    { searchType: "brand_name", searchText: "브랜드명" },
    { searchType: "category", searchText: "카테고리" },
  ];

  const [confirmHistory, setConfirmHistory] = useState({
    target_type: 3,
    confirm: 1,
    confirm_reason: "시작테스트",
  });

  const excelTemplate = [
    {
      brand_name: "브랜드명",
      name: "영양제명",
      category: "영양제 카테고리 프로바이오틱스...",
      for_person_unit: "분량 내용량_단위 (g , ml)",
      for_person: "분량",
      total_dietary_fiber: "식이섬유",
      calcium: "칼슘(mg)",
      fe: "철(mg)",
      magnesium: "마그네슘(mg)",
      perfect_virtue: "인(㎎)",
      potassium: "칼륨(㎎)",
      zinc: "아연(mg)",
      copper: "구리(mg)",
      manganese: "망간(mg)",
      selenium: "셀레늄(㎍)",
      molybdenum: "몰리브덴(㎍)",
      iodine: "요오드(㎍)",
      vitamin_a: "비타민 A(㎍)",
      beta_carotene: "베타카로틴",
      vitamin_d: "비타민 D(μg)",
      vitamin_e: "비타민 E(mg)",
      vitamin_k: "비타민 K(㎍)",
      vitamin_b1: "티아민(비타민 B1)(mg)",
      vitamin_b2: "리보플라빈(비타민 B2)(mg)",
      niacin: "나이아신(비타민 B3)mg NE",
      pantothenic_acid: "판토텐산(비타민 B5)mg",
      pyridoxine: "피리독신(비타민 B6)mg",
      biotin: "비오틴(비타민 B7)",
      folic_acid: "엽산(비타민 B9)μg",
      vitamin_b12: "코발라민(비타민 B12)µg",
      vitamin_c: "비타민 C(mg)",
      omega_3_fatty_acids: "오메가3(mg)",
      chrome: "크롬 ㎍",
      guaranteed: "보장균수(억cfu)",
      lutein: "루테인 mg",
      zeaxanthin: "지아잔틴",
      astaxanthin: "아스타잔틴mg",
      silymarin: "실리마린 mg",
      coq10: "CoQ10 mg",
      ginsenoside: "진세노사이드mg",
      flavonoids: "플라보노이드 mg",
      theanine: "테아닌mg",
      collagen: "콜라겐",
      l_arginine: "L-라이신",
      l_lysine: "L-아르기닌",
      inositol: "이노시톨",
      octacosanol: "옥타코사놀",
      hca: "HCA",
      udca: "UDCA",
      γ_oryzanol: "γ-오리자놀",
      glucosamine: "글루코사민",
      betaglucan: "베타글루칸",
      brewersyeast: "맥주효모",
      oroticacidhydrate: "오로트산수화물",
      hyaluronic_acid: "히알루론산mg",
      glutamic_acid: "폴리감마글루탐산 mg",
      msm: "MSM",
      total_anthocyanosides: "총안토시아노사이드",
      alpha_s_1_casein: "알파에스1카제인",
      cultured_cells: "열처리배양균체 수",
      rosabine: "로사빈",
      lauric_acid: "로르산",
      linolenic_acid: "감마리놀렌산(mg)",
      catechins: "녹차추출물(카테킨)(mg)",
      lactulose: "락추로스(mg)",
    },
  ];
  const excelColumnTemplate = [
    { brand_name: "A" },
    { name: "B" },
    { category: "C" },
    { for_person_unit: "D" },
    { for_person: "E" },
    { total_dietary_fiber: "F" },
    { calcium: "G" },
    { fe: "H" },
    { magnesium: "I" },
    { perfect_virtue: "J" },
    { potassium: "K" },
    { zinc: "L" },
    { copper: "M" },
    { manganese: "N" },
    { selenium: "O" },
    { molybdenum: "P" },
    { iodine: "Q" },
    { vitamin_a: "R" },
    { beta_carotene: "S" },
    { vitamin_d: "T" },
    { vitamin_e: "U" },
    { vitamin_k: "V" },
    { vitamin_b1: "W" },
    { vitamin_b2: "X" },
    { niacin: "Y" },
    { pantothenic_acid: "Z" },
    { pyridoxine: "AA" },
    { biotin: "AB" },
    { folic_acid: "AC" },
    { vitamin_b12: "AD" },
    { vitamin_c: "AE" },
    { omega_3_fatty_acids: "AF" },
    { chrome: "AG" },
    { guaranteed: "AH" },
    { lutein: "AI" },
    { zeaxanthin: "AJ" },
    { astaxanthin: "AK" },
    { silymarin: "AL" },
    { coq10: "AM" },
    { ginsenoside: "AN" },
    { flavonoids: "AO" },
    { theanine: "AP" },
    { collagen: "AQ" },
    { l_arginine: "AR" },
    { l_lysine: "AS" },
    { inositol: "AT" },
    { octacosanol: "AU" },
    { hca: "AV" },
    { udca: "AW" },
    { γ_oryzanol: "AX" },
    { glucosamine: "AY" },
    { betaglucan: "AZ" },
    { brewersyeast: "BA" },
    { oroticacidhydrate: "BB" },
    { hyaluronic_acid: "BC" },
    { glutamic_acid: "BD" },
    { msm: "BE" },
    { total_anthocyanosides: "BF" },
    { alpha_s_1_casein: "BG" },
    { cultured_cells: "BH" },
    { rosabine: "BI" },
    { lauric_acid: "BJ" },
    { linolenic_acid: "BK" },
    { catechins: "BL" },
    { lactulose: "BM" },
  ];
  const columns = [
    {
      title: "id",
      width: 80,
      dataIndex: "id",
      key: "id",
      ellipsis: true,
      fixed: "left",
      onCell: (record) => {
        return {
          onClick: () => {
            history.push(`/nutrients/view/certified/${record.id}`);
          },
        };
      },
      // sorter: (a, b) => {},
    },
    {
      title: "카테고리",
      width: 120,
      dataIndex: "category",
      key: "category",
      ellipsis: true,
      fixed: "left",
      onCell: (record) => {
        return {
          onClick: () => {
            history.push(`/nutrients/view/certified/${record.id}`);
          },
        };
      },
      // sorter: (a, b) => {},
    },
    {
      title: "브랜드명",
      width: 120,
      dataIndex: "brand_name",
      key: "brand_name",
      ellipsis: true,
      fixed: "left",
      onCell: (record) => {
        return {
          onClick: () => {
            history.push(`/nutrients/view/certified/${record.id}`);
          },
        };
      },
      // sorter: (a, b) => {},
    },
    {
      title: "브랜드타입",
      width: 100,
      dataIndex: "brand_type",
      key: "brand_type",
      ellipsis: true,
      fixed: "left",
      onCell: (record) => {
        return {
          onClick: () => {
            history.push(`/nutrients/view/certified/${record.id}`);
          },
        };
      },
      // sorter: (a, b) => {},
    },
    {
      title: "영양제명",
      width: 150,
      dataIndex: "name",
      key: "name",
      fixed: "left",
      ellipsis: true,
      onCell: (record) => {
        return {
          onClick: () => {
            history.push(`/nutrients/view/certified/${record.id}`);
          },
        };
      },
      // sorter: (a, b) => {},
    },
    {
      title: "헬씨팀인증",
      dataIndex: "status",
      key: "status",
      width: 90,
      ellipsis: true,
      render: (e) => {
        return e === 1 ? "인증" : "미인증";
      },
      onCell: (record) => {
        return {
          onClick: () => {
            history.push(`/nutrients/view/certified/${record.id}`);
          },
        };
      },
      // sorter: (a, b) => {},
    },
    {
      title: "분량",
      dataIndex: "nutrition_facts",
      key: "nutrition_facts",
      width: 50,
      ellipsis: true,
    },
    {
      title: "단위",
      dataIndex: "nutrition_facts_unit",
      key: "nutrition_facts_unit",
      width: 50,
      ellipsis: true,
    },
    {
      title: "칼로리(kcal)",
      dataIndex: "energy",
      key: "energy",
      width: 100,
      ellipsis: true,
    },
    {
      title: "1회복용량",
      dataIndex: "for_person",
      key: "for_person",
      width: 70,
      ellipsis: true,
    },
    {
      title: "1회복용 단위",
      dataIndex: "for_person_unit",
      key: "for_person_unit",
      width: 100,
      ellipsis: true,
    },
    {
      title: "유저 설명",
      dataIndex: "user_description",
      key: "user_description",
      width: 100,
      ellipsis: true,
    },
    {
      title: "생성일",
      dataIndex: "created_at",
      key: "created_at",
      width: 150,
      render: (e) => {
        return e === null ? "-" : moment(e).format("YYYY-MM-DD HH:mm");
      },
      ellipsis: true,
      // sorter: (a, b) => {},
    },
    {
      title: "생성자",
      dataIndex: "created_by_name",
      key: "created_by_name",
      render: (e) => {
        return e === 0 ? "Admin" : e;
      },
      width: 100,
      ellipsis: true,
    },
    {
      title: "수정일",
      dataIndex: "updated_at",
      key: "updated_at",
      render: (e) => {
        return e === null ? "-" : moment(e).format("YYYY-MM-DD HH:mm");
      },
      width: 150,
      // sorter: (a, b) => {},
      ellipsis: true,
    },
    {
      title: "수정자",
      dataIndex: "updated_by",
      key: "updated_by",
      render: (e) => {
        return e === 0 ? "Admin" : e;
      },
      width: 100,
      ellipsis: true,
    },
    {
      title: "",
      key: "handleData",
      fixed: "right",
      width: 100,
      ellipsis: true,
      render: () => <a>자세히</a>,
    },
  ];

  useEffect(() => {
    getReadNutrientsData();
    getTotalSize();
  }, [searchText, pageSize, orderType, orderBy, offset]);

  /**
   * 영양제목록 가져오기
   * @param {*} offset
   * @param {*} PageSize
   * @param {*} searchType
   * @param {*} searchText
   * @param {*} orderType
   * @param {*} orderBy
   * @param {*} pageType 1 // 1:인증 2:나만의레시피 3: 신청목록
   */
  const getReadNutrientsData = async () => {
    setIsLoading(true);
    try {
      const res = await nutrientsApi.readNutrients(
        offset,
        pageSize,
        searchType,
        searchText,
        orderType,
        orderBy,
        1,
      );
      if (res.code === 200) {
        setNutrientsData(res.result.nutrientsList);
      } else {
        alert("정상적인 요청이 아닙니다.");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("nutrientsData read error", error);
    }
  };

  /**
   * 테이블 변경 이벤트가 이루어졌을때
   * @param {*} pagination
   * @param {*} filters
   * @param {*} sorter
   * @param {*} extra
   */
  const tableOnChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === "descend") {
          setOrderBy("desc");
        } else if (sorter.order === "ascend") {
          setOrderBy("asc");
        }
        setOrderType(sorter.field);
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType("created_at");
        setOrderBy("desc");
      }
    }
  };

  /**
   *  목록 총 사이즈 가져오기
   */
  const getTotalSize = async () => {
    setIsLoading(true);
    try {
      const res = await nutrientsApi.totalCntList(searchText, searchType, 1);
      if (res.code === 200) {
        setTotalSize(res.result.totalCnt);
      } else {
        alert("정상적인 요청이 아닙니다.");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("nutrients totalCnt error", error);
    }
  };

  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
    setOffset((current - 1) * 10);
    setCurrentPageNumber(1);
  };

  const handleChangeOffset = (pageNumber) => {
    const offset = (pageNumber - 1) * 10;
    setCurrentPageNumber(pageNumber);
    setOffset(offset);
  };

  const onSearchNutrients = (value) => {
    setIsSearchText(value);
    setOffset(0);
    setCurrentPageNumber(1);
    setIsSearch(!isSearch);
  };

  const onChangeSearchType = (value) => {
    setSearchType(value);
  };

  const uploadModal = () => {
    setExcelModalVisible(true);
    validVar = false;
  };

  const handleExcelCancel = () => {
    setExcelModalVisible(false);
    setIsButtonVisible(false);
    validVar = false;
  };

  const excelExport = (event) => {
    if (event.target.value !== "") {
      setExcelData([]); //계속해서 엑셀시트를 추가하고 그걸 연결하고 싶으면 초기화하는 이 문장을 빼면 될 듯.
      let input = event.target;
      let reader = new FileReader();
      reader.onload = function () {
        let fileData = reader.result;
        let wb = XLSX.read(fileData, { type: "binary" });
        let sheetNameList = wb.SheetNames;
        let firstSheet = wb.Sheets[sheetNameList[0]];

        // get header info
        let range = XLSX.utils.decode_range(firstSheet["!ref"]);
        range.s.c = 1;
        let decodeRange = XLSX.utils.encode_range(range);
        range.e.r = 1;
        range.e.c = 35;
        let kpiRange = XLSX.utils.encode_range(range);
        range.s.c = 37;
        range.e.c = 106;
        let infoRange = XLSX.utils.encode_range(range);
        range.s.c = 108;
        range.e.c = 125;
        let allergyRange = XLSX.utils.encode_range(range);

        let kpiHeader = XLSX.utils.sheet_to_json(firstSheet, {
          range: kpiRange,
        })[0];
        let infoHeader = XLSX.utils.sheet_to_json(firstSheet, {
          range: infoRange,
        })[0];
        let allergyHeader = XLSX.utils.sheet_to_json(firstSheet, {
          range: allergyRange,
        })[0];

        let nutrientsExcel = XLSX.utils.sheet_to_json(firstSheet, {
          range: decodeRange,
        });
        let totalHeader = nutrientsExcel.shift();
        setExcelHeaders({
          ...excelHeaders,
          kpiHeader: kpiHeader,
          infoHeader: infoHeader,
          allergyHeader: allergyHeader,
          totalHeader: totalHeader,
        });
        setExcelData(nutrientsExcel);
      };
      reader.readAsBinaryString(input.files[0]);
    }
  };

  const removeNutrientsData = async (id) => {
    setIsLoading(true); // 추가설정해야함. 팀장님거 참고하기.
    try {
      const res = await nutrientsApi.removeNutrients(id);
      if (res.code === 200) {
        /* empty */
      } else {
        alert("정상적인 요청이 아닙니다.");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      setError(error);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      setSelectedData(selectedRows);
    },
  };

  const selectedDelete = () => {
    for (let i = 0; i < selectedData?.length; i++) {
      removeNutrientsData(selectedData[i].id);
      if (i + 1 === selectedData?.length) {
        window.alert("삭제완료");
        setSelectedRowKeys([]);
        getReadNutrientsData();
      }
    }
  };

  const postExcelData = async () => {
    let params = [];
    for (const data of excelData) {
      let nutrient = {};
      let nutrientsKpi = {};
      let nutrientsAllergy = {};
      let nutrientsInfo = {};
      for (const kpiKey in excelHeaders.kpiHeader) {
        if (
          kpiKey === "하루 섭취 횟수" ||
          kpiKey === "회당 개수" ||
          kpiKey === "복용 시간대"
        ) {
          nutrient[excelHeaders.kpiHeader[kpiKey]] = data[kpiKey];
        } else if (
          kpiKey === "브랜드명" ||
          kpiKey === "제품명" ||
          kpiKey === "제품 카테고리" ||
          kpiKey === "TOP 성분" ||
          kpiKey === "하루권장량" ||
          kpiKey === "단위"
        ) {
          nutrientsKpi[excelHeaders.kpiHeader[kpiKey]] = data[kpiKey];
          nutrient[excelHeaders.kpiHeader[kpiKey]] = data[kpiKey];
        } else {
          nutrientsKpi[excelHeaders.kpiHeader[kpiKey]] = data[kpiKey];
        }
      }
      for (const allergyKey in excelHeaders.allergyHeader) {
        nutrientsAllergy[excelHeaders.allergyHeader[allergyKey]] =
          data[allergyKey];
      }
      for (const infoKey in excelHeaders.infoHeader) {
        nutrientsInfo[excelHeaders.infoHeader[infoKey]] = data[infoKey];
      }
      if (nutrientsInfo.hasOwnProperty(nutrientsKpi.top_nutrient_id)) {
        nutrientsKpi.top_nutrient_content =
          nutrientsInfo[nutrientsKpi.top_nutrient_id];
      }
      let nutrientsAllergyVertical = nutrientInfoTransform(
        "nutrientsAllergy",
        nutrientsAllergy,
      );
      let nutrientsNutrientVertical = nutrientInfoTransform(
        "nutrientInfomation",
        nutrientsInfo,
      );
      const createNutrients = {
        nutrients: {
          ...nutrient,
          status: 1,
          is_certify: true,
          created_by: user.id,
          created_by_name: user.nickname,
        },
        nutrientInformation: {
          ...nutrientsInfo,
          target_type: 3,
          created_by: user.id,
          created_by_name: user.nickname,
        },
        nutrientsKpi: {
          ...nutrientsKpi,
          target_type: 3,
          created_by: user.id,
          created_by_name: user.nickname,
        },
        nutrientsAllergy: {
          ...nutrientsAllergy,
          target_type: 3,
          created_by: user.id,
          created_by_name: user.nickname,
        },
        confirmHistory: confirmHistory,
        nutrientInformationVertical: nutrientsNutrientVertical,
        nutrientsAllergyVertical: nutrientsAllergyVertical,
      };
      params.push(createNutrients);
    }
    const res = await nutrientsApi.createExcelNutrients({
      excelDTOList: params,
    });
    if (res.data.code === 200) {
      setIsLoading(false);
      setIsButtonVisible(true);
      setExcelModalVisible(false);
      window.alert("엑셀파일 업로드가 완료되었습니다.");
      getReadNutrientsData();
    } else if (res.data.code === 418) {
      setIsLoading(false);
      let duplication = [];
      for (let i = 0; i < res.data.result?.length; i++) {
        duplication.push(res.data.result[i][0]);
      }
      setIsButtonVisible(true);
      setDuplicationList(duplication);
    } else {
      setIsLoading(false);
      setIsButtonVisible(true);
      setExcelModalVisible(false);
      window.alert("엑셀파일 업로드 중 오류가 발생하였습니다.");
    }
  };

  const handleExcelOk = () => {
    setIsLoading(true);
    if (excelData?.length > 0) {
      console.log("excelData === ", excelData);
      validationExcel();
      if (isButtonVisible === true) {
        postExcelData();
      } else if (validVar === false) {
        setIsLoading(false);
        window.alert("엑셀 유효성검사가 완료되었습니다.");
        setIsButtonVisible(true);
      } else {
        // window.alert('템플릿 수정 후 이용해주세요')
        setIsLoading(false);
        validVar = false;
      }
    } else {
      setIsLoading(false);
      window.alert("엑셀파일(.xlsx)을 추가하세요");
    }
  };

  /**
   * validationExcel 수정 - ksb (2022.10.05)
   * @param files
   */
  const validationExcel = () => {
    if (excelData?.length > 0) {
      for (let i = 0; i < excelData?.length; i++) {
        let data = excelData[i];
        let keys = Object.keys(data);
        if (validVar === false) {
          for (let j = 0; j < keys?.length; j++) {
            let key = keys[j];
            if (validVar === false) {
              if (
                key === "브랜드명" ||
                key === "제품명" ||
                key === "제품 카테고리" ||
                key === "TOP 성분" ||
                key === "단위" ||
                key === "제형" ||
                key === "복용 시간대" ||
                key === "제조사명" ||
                key === "추천이유"
              ) {
                if (typeof data[key] !== "string" && data[key] !== null) {
                  console.log("String type error", key, typeof data[key]);
                  validVar = true;
                }
              } else if (
                key === "특징1" ||
                key === "특징2" ||
                key === "특징3" ||
                key === "리뷰1" ||
                key === "리뷰2" ||
                key === "리뷰3"
              ) {
                if (
                  data[key].includes("효능") ||
                  data[key].includes("효과") ||
                  data[key].includes("피로") ||
                  data[key].includes("피곤") ||
                  data[key].includes("도움") ||
                  data[key].includes("흡수율") ||
                  data[key].includes("질병") ||
                  data[key].includes("탈모") ||
                  data[key].includes("심장벙")
                ) {
                  window.alert(
                    i +
                      3 +
                      "행의 " +
                      key +
                      "에 적절하지 않은 단어가 포함되어 있습니다.",
                  );
                  console.log(
                    "특징 및 리뷰 금지 단어 포함 error",
                    key,
                    data[key],
                  );
                  validVar = true;
                  break;
                }
              } else if (!key.includes("EMPTY")) {
                if (typeof data[key] !== "number") {
                  console.log("number type error", key, typeof data[key]);
                  validVar = true;
                }
              }
            } else if (validVar === true) {
              window.alert(
                i +
                  2 +
                  "행에 입력된 영양제의 " +
                  keys[j - 1] +
                  " 항목의 정보가 잘못 기입되었습니다.",
              );
              break;
            } else {
              window.alert("오류가 발생했습니다.");
              break;
            }
          }
        } else {
          break;
        }
      }
    } else {
      validVar = true;
      window.alert("템플릿 수정 후 이용해주세요");
    }
  };

  const nutrientInfoTransform = (type, data) => {
    let result = [];
    if (type === "nutrientInfomation") {
      for (const key in data) {
        if (key !== "target_type") {
          result.push({
            target_id: 0,
            target_type: 3,
            nutrient_id: key,
            nutrient_content: data[key],
            created_by: user.id,
            created_by_name: user.nickname,
          });
        }
      }
    } else if (type === "nutrientsAllergy") {
      for (const key in data) {
        if (key !== "target_type") {
          result.push({
            target_id: 0,
            target_type: 3,
            nutrient_id: key,
            nutrient_allergy: data[key],
            created_by: user.id,
            created_by_name: user.nickname,
          });
        }
      }
    }

    return result;
  };

  return (
    <>
      <div
        style={{
          marginBottom: 20,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div className="searchBox">
          <Select
            style={{ width: 120, textAlign: "left" }}
            defaultValue={searchType}
            onChange={onChangeSearchType}
          >
            {searchItems.map((item) => {
              return <Option value={item.searchType}>{item.searchText}</Option>;
            })}
          </Select>
          <Search
            placeholder="input search text"
            allowClear
            enterButton="Search"
            defaultValue={searchText}
            size="middle"
            onSearch={onSearchNutrients}
            style={{ width: 250 }}
          />
          <ButtonGroup>
            <Button
              onClick={uploadModal}
              style={{
                width: 130,
                height: 30,
                marginLeft: 20,
                marginBottom: 20,
                borderColor: "#00bbff",
              }}
            >
              엑셀파일 업로드
            </Button>
            <Button
              style={{
                width: 130,
                height: 30,
                marginLeft: 20,
                marginBottom: 20,
                borderColor: "rgb(215,211,41)",
              }}
              href={`${process.env.REACT_APP_HOST}/assets/files/Nutrients_Template.xlsx`}
            >
              {" "}
              엑셀파일 내려받기{" "}
            </Button>
          </ButtonGroup>
        </div>
        <ButtonGroup
          style={{
            marginTop: 10,
            marginRight: 40,
            display: "flex",
            justifyContent: "right",
          }}
        >
          <div style={{ paddingTop: "5px" }}>
            Total : {totalSize.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </div>
          <Button
            style={{
              width: 120,
              height: 30,
              marginLeft: 20,
              marginBottom: 20,
              borderColor: "#ff0000",
            }}
            onClick={selectedDelete}
          >
            {" "}
            선택영양제삭제{" "}
          </Button>
          <Button
            style={{
              width: 120,
              height: 30,
              marginLeft: 20,
              marginBottom: 20,
              borderColor: "#17721b",
            }}
            onClick={() => {
              history.push(`/nutrients/certified/create`);
            }}
          >
            영양제추가
          </Button>
        </ButtonGroup>
      </div>
      <Modal
        title="엑셀 업로드"
        visible={excelModalVisible}
        maskClosable={false}
        onCancel={handleExcelCancel}
        footer={[
          <Button
            key="back"
            onClick={handleExcelCancel}
            loading={isLoading}
            disabled={isLoading}
          >
            돌아가기
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={isLoading}
            disabled={isButtonVisible}
            onClick={handleExcelOk}
          >
            유효성검사하기
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={isLoading}
            disabled={!isButtonVisible}
            onClick={handleExcelOk}
          >
            자료업로드하기
          </Button>,
        ]}
      >
        <p>* 업로드할 엑셀파일을 선택해주세요(.xlsx)</p>
        <p>* 초록 : 필수 입력사항 </p>
        <p>* 노랑 : 없을 시 하이픈(-)처리</p>
        <p>* 파랑 : 없으면 공란 </p>

        <input
          disabled={isButtonVisible}
          type={"file"}
          id="excelFile"
          onChange={excelExport}
        />

        {duplicationList && (
          <>
            <p>중복 영양제 항목 ( [브랜드/카테고리] 영양제명 )</p>
            {duplicationList.map((duplicationItem, index) => {
              return (
                <>
                  <div>
                    ({index + 1}) [
                    {duplicationItem.brand_name
                      ? duplicationItem.brand_name
                      : duplicationItem.category}
                    ] {duplicationItem.name}
                  </div>
                </>
              );
            })}
          </>
        )}
      </Modal>
      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={nutrientsData}
        loading={isLoading}
        bordered
        size="middle"
        rowKey="id"
        scroll={{ x: "calc(700px + 50%)" }}
        onChange={tableOnChange}
        pagination={false}
      />

      <div style={{ textAlign: "right" }}>
        <Pagination
          showQuickJumper
          showSizeChanger
          onShowSizeChange={pageSizeChange}
          total={totalSize}
          onChange={handleChangeOffset}
          style={{ marginTop: 20 }}
          current={currentPageNumber}
        />
      </div>
    </>
  );
};
export default NutrientsCertifiedComponent;
